import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BusinessMemberProfile } from "../../../types/business";
import { RootState } from "../../../store";
import * as triplinkService from '../../../utils/triplinkService'
import { logout } from "../auth/authSlice";

interface BusinessMemberState {
  body: BusinessMemberProfile[] | null;
  updating: boolean;
}

const initialState: BusinessMemberState = {
  body: null,
  updating: false,
}

// Thunk
export const fetchBusinessMembers = createAsyncThunk(
  'business/fetchBusinessMembers',
  async (params, {dispatch, getState}) => {
    const state: RootState = (getState() as RootState);
    const accessToken = state.accessToken.body;
    if (!accessToken) {
      throw new Error('Cannot fetchBusinessMembers without accessToken')
    }
    const result = await triplinkService.getMyBusinessMembers(accessToken)

    return {
      businessMember: result,
      requiresAccessToken: true,
    }
  }
)

const businessMemberSlice = createSlice({
  name: 'businessMember',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder
    .addCase(logout, (state) => {
      state.body = null
      state.updating = false
    })
    .addCase(fetchBusinessMembers.pending, (state, action) => {
      state.updating = true
    })
    .addCase(fetchBusinessMembers.fulfilled, (state, action) => {
      state.updating = false
      state.body = action.payload.businessMember
    })
    .addCase(fetchBusinessMembers.rejected, (state, action) => {
      state.updating = false
      state.body = null
    })
  }
})

export const {
} = businessMemberSlice.actions

export const selectBusinessMember = (state: RootState) => state.business_member

export default businessMemberSlice.reducer